class CreateSiteMessageAPIMessage {
  constructor(
    public user_id: string,
    public account_id: string,
    public title: string,
    public tagline: string,
    public sub_domain: string,
    public template_id: string,
    public multisite: boolean,
  ) {}
}

export class SiteCreateMessageV2 {
  constructor(
    private _accountId: string,
    private _title: string,
    private _tagline: string,
    private _subDomain: string,
    private _userId?: string,
    private _templateId?: string,
    private _multisite?: boolean,
  ) {}

  get subDomain(): string {
    return this._subDomain;
  }

  get title(): string {
    return this._title;
  }

  get tagline(): string {
    return this._tagline;
  }

  get accountId(): string {
    return this._accountId;
  }

  get userId(): string {
    return this._userId;
  }

  get templateId(): string {
    return this._templateId;
  }

  get multisite(): boolean {
    return this._multisite;
  }

  public toApi(): CreateSiteMessageAPIMessage {
    return new CreateSiteMessageAPIMessage(
      this.userId,
      this.accountId,
      this.title,
      this.tagline,
      this.subDomain,
      this.templateId,
      this.multisite,
    );
  }
}

export interface CreateSiteResponseV2JSON {
  data: CreateSiteAPIResponseV2;
}

interface CreateSiteAPIResponseV2 {
  site_id: string;
  job_id: string;
}

export class SiteCreateResponseV2 {
  constructor(
    private _siteId: string,
    private _jobId: string,
  ) {}

  get jobId(): string {
    return this._jobId;
  }

  get siteId(): string {
    return this._siteId;
  }

  public static fromApi(createResponse: CreateSiteAPIResponseV2): SiteCreateResponseV2 {
    return new SiteCreateResponseV2(createResponse.site_id, createResponse.job_id);
  }
}
